import React from "react";

export default function RecomendacionesDieteticasEspesantes() {
  return (
    <div className="p-4 max-w-xl mx-auto flex flex-col gap-4">
      {/* Encabezado */}
      <div className="flex items-center justify-center">
        <h4 className="font-bold text-center">Recomendaciones dietéticas sobre el uso de espesante</h4>
      </div>

      {/* Texto + descargable */}
      <div className="flex flex-col gap-4 mt-2">

        {/* Recomendaciones */}
        <div className="bg-[#f4f8fc] p-6 rounded-lg shadow">
          <div className="text-justify space-y-4">
            <p>Debe utilizar el cacito medidor que encontrará dentro del envase del espesante.</p>

            <hr className="border-gray-300" />

            <p>Utilice siempre la cantidad indicada de espesante según la textura o viscosidad deseada en un vaso limpio y seco o en una taza.</p>

            <hr className="border-gray-300" />

            <p>Si su espesante es “Clear” o contiene goma Xantana, deberá incorporar a continuación, el líquido. Si se trata de un espesante de almidón de maíz el orden es indiferente.</p>

            <hr className="border-gray-300" />

            <p>Remueva la mezcla suavemente con una cuchara durante 20 segundos, evitando la formación de burbujas.</p>

            <hr className="border-gray-300" />

            <p>Espere un minuto antes de ingerirlo.</p>
          </div>
        </div>

        {/* Recuerde */}
        <div className="bg-[#dfeaf7] p-6 rounded-lg shadow">
          <p className="text-justify font-semibold mb-4">
            RECUERDE:
          </p>

          <ol className="text-justify list-decimal list-inside space-y-2">
            <li>No mezcle el espesante con bebidas muy calientes o hirviendo. Antes de mezclar asegúrese de que el líquido se ha enfriado un poco.</li>
            <li>Si su espesante es “Clear” o contiene goma Xantana, evite mezclar con un tenedor porque facilita la entrada de aire y aparecen burbujas en la mezcla.</li>
            <li>En caso de duda consulte con su profesional sanitario.</li>
          </ol>
        </div>

        {/* Descargable */}
        <div className="flex items-center">
          <p className="text-justify gap-4 mt-2 mb-4">
            Si desea obtener el descargable, pulse en el siguiente{" "}
            <a
              href="/docs/recomendaciones-dieteticas-espesante.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
            enlace
            </a>.
          </p>
        </div>
      </div>
    </div>
  );
}